// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__wUzsG","carouselWrapper":"Carousel_carouselWrapper__5rGVN"};